<template>
    <div class="quick-filter">
        <span class="filter-label">快速筛选：</span>
        <ButtonGroup>
            <Button
                :type="activeFilter === 'all' ? 'primary' : 'default'"
                size="small"
                @click="handleFilter('all')"
            >
                全部
            </Button>
            <Button
                :type="activeFilter === 'error' ? 'error' : 'default'"
                size="small"
                @click="handleFilter('error')"
            >
                错误
            </Button>
            <Button
                :type="activeFilter === 'slow' ? 'warning' : 'default'"
                size="small"
                @click="handleFilter('slow')"
            >
                慢查询
            </Button>
            <Button
                :type="activeFilter === 'post' ? 'primary' : 'default'"
                size="small"
                @click="handleFilter('post')"
            >
                POST请求
            </Button>
            <Button
                :type="activeFilter === 'api' ? 'info' : 'default'"
                size="small"
                @click="handleFilter('api')"
            >
                API接口
            </Button>
        </ButtonGroup>
        <Divider type="vertical" />
        <span class="time-filter">
            <span class="filter-label">时间范围：</span>
            <ButtonGroup>
                <Button
                    :type="activeTimeRange === '1h' ? 'primary' : 'default'"
                    size="small"
                    @click="handleTimeRange('1h')"
                >
                    近1小时
                </Button>
                <Button
                    :type="activeTimeRange === '24h' ? 'primary' : 'default'"
                    size="small"
                    @click="handleTimeRange('24h')"
                >
                    近24小时
                </Button>
                <Button
                    :type="activeTimeRange === '7d' ? 'primary' : 'default'"
                    size="small"
                    @click="handleTimeRange('7d')"
                >
                    近7天
                </Button>
                <Button
                    :type="activeTimeRange === '30d' ? 'primary' : 'default'"
                    size="small"
                    @click="handleTimeRange('30d')"
                >
                    近30天
                </Button>
            </ButtonGroup>
        </span>
    </div>
</template>

<script>
export default {
    name: "QuickFilter",
    data() {
        return {
            activeFilter: 'all',
            activeTimeRange: null
        };
    },
    methods: {
        handleFilter(type) {
            this.activeFilter = type;
            this.$emit('on-filter', type);
        },
        handleTimeRange(range) {
            this.activeTimeRange = range;
            this.$emit('on-time-range', range);
        },
        reset() {
            this.activeFilter = 'all';
            this.activeTimeRange = null;
        }
    }
};
</script>

<style lang="less" scoped>
.quick-filter {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 8px;

    .filter-label {
        color: #666;
        font-size: 14px;
    }

    .time-filter {
        display: flex;
        align-items: center;
    }
}
</style>